import axios, { AxiosInstance } from 'axios';

const baseURLs = {
  test: 'http://apm.gz.cvte.cn/grail',
  production: 'http://myou.cvte.com/grail',
};

const dataIds = {
  test: 'cloud_bhppagcldfmaphij',
  production: 'cloud_ljpdliihkggdocmn',
};

export type Env = 'test' | 'production';

interface Props {
  env?: Env;
}

class Reporter {
  private env: Env;
  private instance: AxiosInstance | null = null;
  constructor(props?: Props) {
    let env: Env = 'test';
    if (props && props.env) {
      env = props.env;
    }
    this.env = env;
    this._createInstance();
  }

  private _createInstance = () => {
    const instance = axios.create({
      baseURL: baseURLs[this.env],
      timeout: 1000,
      validateStatus: function (status) {
        return status >= 200 && status < 300;
      },
    });

    instance.defaults.headers.common['X-Data-Id'] = dataIds[this.env];
    instance.defaults.headers.post['Content-Type'] = 'application/json';

    this.instance = instance;
  };

  private _changeInstanceConfig = () => {
    if (!this.instance) return;

    this.instance.defaults.baseURL = baseURLs[this.env];
    this.instance.defaults.headers.common['X-Data-Id'] = dataIds[this.env];
  };

  public setEnv = (env: Env) => {
    this.env = env;
    this._changeInstanceConfig();
  };

  public report = async (data: object[]) => {
    try {
      return await this.instance?.post('/api/report/raw', data);
    } catch (error) {
      return error;
    }
  };
}

export default Reporter;
